import { useMutation, useQueryClient } from 'react-query';

import type { TVendorCodeCommercialHomeWarranty } from './../../../models/vendor/VendorCodeModels';
import type { TCreateModel } from '../../../utils/hookUtils';
import QUERYKEYS from '../../../constants/queryKeys';
import { createVendorCodeCommercialHomeWarranty } from './../../../services/VendorCodesService';

const useCreateVendorCodeCommercialHomeWarranty =
  (): TCreateModel<TVendorCodeCommercialHomeWarranty> => {
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation(createVendorCodeCommercialHomeWarranty, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) =>
            query.queryKey === QUERYKEYS.VENDOR_CODES || query.queryKey[0] === QUERYKEYS.VENDORS,
        });
      },
    });

    return {
      create: mutate,
      isLoading,
    };
  };

export default useCreateVendorCodeCommercialHomeWarranty;
